import { apiSlice } from "../../app/api/apiSlice"

// 定義工作許可證的數據類型
interface WorkPermitData {
    scheduleID: string;
    mode: 'create' | 'edit';
    site: string;
    content: string;
    contractor: string;
    approver: string;
    riskReportDate: string;
    entryDate: string;
    entryTime: string;
    expiryDate: string;
    expiryTime: string;
    maxStayHour: number;
    workers: Array<{
        name: string;
        idNumber: string;
        idExpiry: string; // Date format: "2025-07-29"
        sign: string;
    }>;
    standbyWorkers: Array<{
        name: string;
        trainingDate: string; // Date format: "2025-07-29"
        duty: string;
        sign: string;
    }>;
    rescueWorkers: Array<{
        name: string;
        trainingDate: string; // Date format: "2025-07-29"
        duty: string;
        sign: string;
    }>;
    groundPipeOptions: {
        isSubjectToRegulation: boolean;
        requireRespiratoryEquipment: boolean;
        requireGasMonitoring: boolean;
        isNotSubjectToRegulation: boolean;
        notSubjectReason: string;
    };
    isolationOptions: Array<{
        label: string;
        checked: boolean;
        sign: string;
        date: string; // ISO 8601 format: "2025-07-29T03:13:02.180Z"
    }>;
    ventOptions: Array<{
        label: string;
        checked: boolean;
        sign: string;
        date: string; // ISO 8601 format: "2025-07-29T03:13:02.180Z"
    }>;
    airTests: Array<{
        date: string; // Date format: "2025-07-29"
        deviceModel: string;
        deviceSerial: string;
        deviceValid: string; // Date format: "2025-07-29"
        locations: Array<{
            place: string;
            time: string; // Time format: "14:30"
            result: {
                oxygen: string;
                lowerLimit: string;
                h2s: string;
                co: string;
            };
        }>;
        responsibleName: string;
        sign: string;
    }>;
    safetyMeasures: Array<{
        label: string;
        checked: boolean;
    }>;
    emergencyEquipments: Array<{
        label: string;
        checked: boolean;
        qty?: string;
        desc?: string;
        car?: boolean;
        tripod?: boolean;
        other?: string;
    }>;
    emergencyConfirm: boolean;
    protectiveEquipments: Array<{
        label: string;
        checked: boolean;
        qty?: string;
        desc?: string;
    }>;
    declarations: Array<{
        title: string;
        desc: string;
        stakeholder?: string;
        validDate?: string; // Date format: "2025-07-29"
        validTime?: string; // Time format: "14:30"
        sign: string;
        name: string;
        position: string;
        date: string; // ISO 8601 format: "2025-07-29T03:13:02.180Z"
    }>;
}

export const WorkPermitSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        // 更新工作許可證
        updateWorkPermit: builder.mutation<any, WorkPermitData>({
            query: (data) => ({
                url: `/WorkSchedule/${data.scheduleID}/WorkPermit`,
                method: 'PUT',
                body: data,
            }),
            // 提供樂觀更新
            async onQueryStarted({ scheduleID }, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    // 可以在這裡添加成功後的處理邏輯
                } catch {
                    // 錯誤處理
                }
            },
        }),

        // 獲取工作許可證
        getWorkPermit: builder.query<any, string>({
            query: (scheduleID) => ({
                url: `/WorkSchedule/${scheduleID}/WorkPermit`,
            }),
        }),

        // 創建工作許可證
        createWorkPermit: builder.mutation<any, WorkPermitData>({
            query: (data) => ({
                url: `/WorkSchedule/${data.scheduleID}/WorkPermit`,
                method: 'PUT',
                body: data,
            }),
        }),

        // 刪除工作許可證
        deleteWorkPermit: builder.mutation<any, string>({
            query: (scheduleID) => ({
                url: `/WorkSchedule/${scheduleID}/WorkPermit`,
                method: 'DELETE',
            }),
        }),
    })
})

export const {
    useUpdateWorkPermitMutation,
    useGetWorkPermitQuery,
    useCreateWorkPermitMutation,
    useDeleteWorkPermitMutation,
} = WorkPermitSlice